/*BUG
 *
 * Handles the "Checkout" button inside a popup.
 *
 * If this function is removed, on the checkout page the quantities of products will be switched
 * when one product has 2 pieces in cart and the other less than 2 pieces in cart.
 * The cause of this issue remains to be investigated.
 *
 * @param {Event} event - The event triggered by clicking the "Checkout" button.
 */
function openModal(event) {
	event.preventDefault();
	window.location.href = '/checkout';
}
